import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import CONFIG          from './config';
import Login           from './pages/Login';
import OrdersPage      from './pages/OrdersPage';
import InvoicesPage    from './pages/InvoicesPage';
import ForwardsPage    from './pages/ForwardsPage';
import DiscountingPage   from './pages/DiscountingPage';
import RealisationsPage  from './pages/RealisationsPage';
import BanksPage       from './pages/BanksPage';
import PcfcPage        from './pages/PcfcPage';
import RateUpload      from './pages/RateUpload';
import DashboardPage   from './pages/DashboardPage';
import PerformancePage from './pages/PerformancePage';
import CFOPage         from './pages/CFOPage';

function App() {
  const [activePage, setActivePage] = useState('orders');
  const [token,    setToken]    = useState(localStorage.getItem('fxToken') || '');
  const [isAdmin,  setIsAdmin]  = useState(false);
  const [userName, setUserName] = useState('');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      if (!token) { setChecking(false); return; }
      setChecking(true);
      try {
        const res = await axios.get(`${CONFIG.AUTH_API}/users/verify`, {
          headers: { authorization: `Bearer ${token}` }
        });
        const u = res.data?.user || res.data || {};
        if (!cancelled) {
          setUserName(u.fullName || u.name || u.FullName || 'User');
          setIsAdmin(Boolean(u.isAdmin || u.IsAdmin || u.admin));
          setChecking(false);
        }
      } catch (err) {
        if (!cancelled) {
          localStorage.removeItem('fxToken');
          setToken('');
          setUserName('');
          setIsAdmin(false);
          setChecking(false);
        }
      }
    };

    verify();
    return () => { cancelled = true; };
  }, [token]);

  const handleLogin = (newToken) => {
    setToken(newToken);
  };

  const handleLogout = () => {
    localStorage.removeItem('fxToken');
    setToken('');
    setUserName('');
    setIsAdmin(false);
    setActivePage('orders');
  };

  if (checking) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#0a0f1c', color: '#7f8da3',
        fontFamily: 'system-ui, Arial, sans-serif' }}>
        Loading…
      </div>
    );
  }

  if (!token) {
    return (
      <GoogleOAuthProvider clientId={CONFIG.GOOGLE_CLIENT_ID}>
        <Login onLogin={handleLogin} />
      </GoogleOAuthProvider>
    );
  }

  const tabs = [
    { key: 'orders',      label: 'Orders'      },
    { key: 'invoices',    label: 'Invoices'    },
    { key: 'discounting', label: 'Discounting' },
    { key: 'realisation', label: 'Realisation' },
    { key: 'forwards',    label: 'Forwards'    },
    { key: 'pcfc',        label: 'PCFC'        },
    { key: 'banks',       label: 'Banks'       },
    { key: 'dashboard',   label: 'Dashboard'   },
    { key: 'performance', label: 'Performance' },
    { key: 'cfo',         label: 'CFO View'    },
  ];

  return (
    <div>

      <div className="topbar">
        <div className="topbar-logo">
          <div className="topbar-logo-box">FX</div>
          <div>
            <div className="topbar-title">FX Capital India</div>
            <div className="topbar-subtitle">Bill Management</div>
          </div>
        </div>
        <div className="topbar-right" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {userName && (
            <div style={{ fontSize: '12px', color: '#94a3b8' }}>
              {isAdmin && (
                <span style={{ background: '#1F4E79', color: '#fff',
                  borderRadius: '4px', padding: '2px 6px',
                  fontSize: '10px', marginRight: '6px', fontWeight: '600' }}>
                  ADMIN
                </span>
              )}
              {userName}
            </div>
          )}
          <div className="live-badge">
            <div className="live-dot"></div>
            Live
          </div>
          <button onClick={handleLogout}
            style={{ background: 'transparent', border: '1px solid #2a3a55',
              color: '#94a3b8', borderRadius: '6px', padding: '5px 12px',
              fontSize: '12px', cursor: 'pointer' }}>
            Logout
          </button>
        </div>
      </div>

      <div className="tab-bar">
        {tabs.map(t => (
          <div key={t.key}
            className={`tab ${activePage === t.key ? 'active' : ''}`}
            onClick={() => setActivePage(t.key)}>
            {t.label}
          </div>
        ))}
        {isAdmin && (
          <div
            className={`tab ${activePage === 'rates' ? 'active' : ''}`}
            onClick={() => setActivePage('rates')}
            style={{ color: activePage === 'rates' ? '' : '#f59e0b' }}>
            📈 Rates
          </div>
        )}
      </div>

      <div className="page-body">
        {activePage === 'orders'      && <OrdersPage      token={token} />}
        {activePage === 'invoices'    && <InvoicesPage    token={token} />}
        {activePage === 'discounting' && <DiscountingPage token={token} />}
        {activePage === 'realisation' && <RealisationsPage token={token} />}
        {activePage === 'forwards'    && <ForwardsPage    token={token} />}
        {activePage === 'pcfc'        && <PcfcPage         token={token} />}
        {activePage === 'banks'       && <BanksPage       token={token} />}
        {activePage === 'dashboard'   && <DashboardPage   token={token} />}
        {activePage === 'performance' && <PerformancePage token={token} />}
        {activePage === 'cfo'         && <CFOPage          token={token} />}
        {activePage === 'rates' && isAdmin && <RateUpload token={token} />}
        {activePage === 'rates' && !isAdmin && (
          <div className="content">
            <p style={{ color: '#c00', padding: '20px' }}>
              Access denied — Admin only
            </p>
          </div>
        )}
      </div>

    </div>
  );
}

export default App;